import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
interface FollowUpOption {
  value: number;
  label: string;
}
@Component({
  selector: "fury-add-followup",
  templateUrl: "./add-followup.component.html",
  styleUrls: ["./add-followup.component.scss"],
})
export class AddFollowupComponent {
  followUpOptions: FollowUpOption[] = [
    { value: 0, label: "None" },
    { value: 1, label: "No Answer" },
    { value: 2, label: "Line Busy" },
    { value: 3, label: "Not Interested" },
    { value: 4, label: "Wrong Number" },
    { value: 5, label: "Meet At The Gym" },
    { value: 6, label: "Follow Up Call" },
    { value: 7, label: "Membership Done" },
  ];
  selectedFollowUp: number = 0;
  note: string = "";
  nextDate: string = "";

  constructor(
    public dialogRef: MatDialogRef<AddFollowupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any[],
  ) {}

  close(): void {
    this.dialogRef.close();
  }
  save() {
    this.dialogRef.close({
      followUpType: this.selectedFollowUp,
      note: this.note,
      nextDate: this.nextDate,
    });
  }
}
